/**
 * Utilidades para manejo de zonas horarias
 * Consolidado desde múltiples ubicaciones para evitar duplicación
 * Específicamente optimizado para la zona horaria de Ecuador (America/Guayaquil)
 */

export class TimezoneUtils {
  /**
   * Formatea una fecha en la zona horaria de Ecuador (America/Guayaquil)
   */
  static formatEcuadorDate(
    utcDate: Date | string,
    options?: Intl.DateTimeFormatOptions
  ): string {
    const date = typeof utcDate === 'string' ? new Date(utcDate) : utcDate;
    const defaultOptions: Intl.DateTimeFormatOptions = {
      timeZone: 'America/Guayaquil',
      ...options
    };
    return date.toLocaleString('es-EC', defaultOptions);
  }

  /**
   * Formatea solo la fecha (sin hora)
   */
  static formatEcuadorDateOnly(utcDate: Date | string): string {
    return this.formatEcuadorDate(utcDate, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  /**
   * Formatea fecha y hora
   */
  static formatEcuadorDateTime(utcDate: Date | string): string {
    return this.formatEcuadorDate(utcDate, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  /**
   * Formatea solo la hora
   */
  static formatEcuadorTimeOnly(utcDate: Date | string): string {
    return this.formatEcuadorDate(utcDate, {
      hour: '2-digit',
      minute: '2-digit'
    });
  }
}
